{
  "erreurs.code.CONTINUITY_REPRISE_HORS_ETAT": "Only a request of the same kind that failed or was interrupted on the host can be resumed.",
  "erreurs.code.CONTINUITY_REQUEST_UNKNOWN": "This backup or restore request is unknown: reload the list of requests.",
  "erreurs.code.PROFIL_DEJA_ATTRIBUE": "This account already holds this platform profile.",
  "erreurs.code.PROFIL_NON_DELEGABLE": "Only the “Operations read-only” and “Support” profiles can be delegated here; platform administration is appointed by two people.",
  "erreurs.code.TACHE_DEJA_EN_COURS": "A run of this scheduled task is already in progress: wait for it to finish before rerunning it.",
  "journalAudit.action.platform.profile_granted": "Platform profile granted",
  "journalAudit.action.platform.profile_revoked": "Platform profile revoked",
  "journalAudit.action.platform.scheduled_task_rerun": "Scheduled task rerun"
}
